/**
 * Returns a new processes array where each process has `frozen: boolean`.
 * The value is taken from the first matching weigh-in process row:
 * `wip.process_id === process.id` => `process.frozen = Boolean(wip.frozen)`.
 *
 * @param {any[]} processes
 * @param {any[]} weighInProcesses
 */
export function withFrozen(processes, weighInProcesses) {
    const procs = Array.isArray(processes) ? processes : []
    const wips = Array.isArray(weighInProcesses) ? weighInProcesses : []

    return procs.map((p) => {
        const pid = p?.id ?? null
        const match = wips.find((wip) => String(wip?.process_id ?? "") === String(pid ?? ""))
        return {
            ...p,
            frozen: Boolean(match?.frozen),
        }
    })
}

